$(document).ready(function () {
    var visitedURLDiscountArray;
    checkCouponCode();
    discount();
});
/* Coupon Code working */
function checkCouponCode() {
  // get the url of the page, match with each li, if URL matches then get the coupon code and save it in  Locals
  let url = $(location).attr("href");
  console.log("current page URL: " + url);
  let couponURL;
  let couponCode;
  // loop through each item in array to match the URL
  console.log("couponCodeArray: " + couponCodeArray);
  $.each(couponCodeArray, function (key, value) {
    //console.log("IN EACH: " + value);
    value = value.split("~");
    couponURL = value[0];
    couponCode = value[1];
    //console.log(couponURL);
     //console.log(couponCode);
    // if url is matched, then saved the couponcode in storage so that we can use it on the checkout page
    if (couponURL == url) {
      //console.log("couponcodeURL matched");
      // on checkout the couponcode would be 1 only. Which ever last URL the customer has visited that couponCode will be saved in storage
      localStorage.setItem("couponCode", couponCode);
    }
  });
}
/* discount working */
function discount() {
  let visitedArrayLength = 0;
   //console.log(discountArray);
  let productRequired;
  let productAddedFree;
  let discountURL;
  let url = window.location.href.split("?")[0];
  /* Check if there is local storage */
  if (localStorage.LocalVisitedURLDiscountArray == undefined) {
     //console.log("local storage undefined");
    visitedURLDiscountArray = {};
  } else {
  /* If YES, then pass the value to a variable */
     //console.log("local storage NOT undefined");
    visitedURLDiscountArray = JSON.parse(
      localStorage.LocalVisitedURLDiscountArray
    );
    // console.log(visitedURLDiscountArray);
  }
  if (visitedURLDiscountArray != null) {
    if (url in visitedURLDiscountArray) {
      //console.log("URL IN ARRAY");
    } else {
      $.each(discountArray, function (key, value) {
        value = value.split("~");
        productRequired = value[0];
        productAddedFree = value[1];
        discountURL = value[2];
        // check if the url is matched, then add a cookie so that it can be used later of the customer adds the required product in the cart
        if (discountURL == url) {
          //console.log("discountURL: " + discountURL);
          //console.log("url: " + url);
          visitedURLDiscountArray[url] = true;
          localStorage.setItem("cartDiscount", true);
        }
      });
      localStorage.setItem(
        "LocalVisitedURLDiscountArray",
        JSON.stringify(visitedURLDiscountArray)
      );
    //   console.log(localStorage.getItem("LocalVisitedURLDiscountArray"));
    }
  }
}